/// FOURJS_START_COPYRIGHT(D,2014)
/// Property of Four Js*
/// (c) Copyright Four Js 2014, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("GridController", ["ControllerBase", "ControllerFactory"], function (context, cls) {
  /**
   * @class GridController
   * @memberOf classes
   * @extends classes.ControllerBase
   */
  class GridController extends cls.ControllerBase /** @lends classes.GridController.prototype */ {
    static __name = "GridController";

    _initBehaviors() {
      super._initBehaviors();

      // These behaviors should stay added at first
      // WARNING : DO NOT ADD BEHAVIORS BEFORE
      this._addBehavior(cls.LayoutInfoVMBehavior);
      this._addBehavior(cls.StyleVMBehavior);
      // END WARNING

      // 4st behaviors
      this._addBehavior(cls.Reverse4STBehavior);

      // vm behaviors
      this._addBehavior(cls.HiddenVMBehavior);
      this._addBehavior(cls.BackgroundColorVMBehavior);
      this._addBehavior(cls.FontFamilyVMBehavior);
      // ui behaviors
      this._addBehavior(cls.OnCopyArrayUIBehavior);
      this._addBehavior(cls.GridAutomaticStack4STBehavior);
    }

    /**
     * @inheritDoc
     */
    ensureVisible(executeAction = false) {
      const widget = this.getAnchorNode().getWidget();
      widget.emit(context.constants.widgetEvents.splitViewChange, widget);
      return super.ensureVisible(executeAction);
    }

    /**
     * If there is a ScrollAreaNode as a child of this grid.
     * That mean the grid is used as a matrix.
     * So we can get the current row from this scrollArea.
     * @returns {number} The current row index. -1 if no ScrollArea node
     */
    getCurrentRow() {
      const scrollAreaNode = this.getAnchorNode().getFirstChild("ScrollArea");
      if (!scrollAreaNode) {
        return -1;
      }
      return scrollAreaNode.getController().getCurrentRow();
    }

    /**
     * If there is a ScrollAreaNode as a child of this grid.
     * That mean the grid is used as a matrix.
     * So we can get the offset from this scrollArea.
     * @returns {number} The current display offset. -1 if no ScrollArea node
     */
    getOffset() {
      const scrollAreaNode = this.getAnchorNode().getFirstChild("ScrollArea");
      if (!scrollAreaNode) {
        return -1;
      }
      return scrollAreaNode.getController().getOffset();
    }
  }

  cls.GridController = GridController;
  cls.ControllerFactory.register("Grid", cls.GridController);
});
